export default {
  lang: {
    selectAll: '全選當頁',
    selected: '已選擇',
    term: '條',
    deselect: '取消選擇',
  },
};
